import React, { useEffect } from 'react';
import { WidgetContainer,ContentHeaderView } from 'components/shared';
import './styles.css';
import  {useModel, useStateManager,DisabledPrompt } from "bcms-react";


/**
 * @function QuickLinksWidget
 * @param {String} className - Allows us to set a custom class name for the component
 * @return {React.Component}
 * @exported true
 * @description The widget that shows Credit Sense in a iframe
 */

export default function QuickLinksWidget(props){
  const className = props.className ?? "";
   const { branding } = useModel();
  let _branding = { colors: branding.colors, options: branding.options};
  let items = [1,2,3,4,5,6,7,8,9,10]
  items = items.map(function(item){
    return {"include":branding.options[`quicklinks_item${item}_include_abi22`],
            "label":branding.options[`quicklinks_item${item}_label_abi22`],
            "url":branding.options[`quicklinks_item${item}_url_abi22`],           
           }
  })
  let links = items.reduce(function(links,item,index){
    if(item.include == "true" ){
      if(item.url){
        let urlIsInCurrABI22 = false;

        if(item.url && item.url.includes("/bcms/click/abi22/")) {
          urlIsInCurrABI22 = true;
        }
      
        links.push( <span className={'quickLink_wrapper quickLink_wrapper_selector_'+index} ><a href={item.url} data-point={"quick_link_"+index} className='clickable quickLink_label' target={urlIsInCurrABI22?"_self":"_blank"}>{item.label}</a></span>)
      }else{
        links.push(<DisabledPrompt><span className='quickLink_wrapper' ><a href={item.url} data-point={"quick_link_"+index} className='clickable quickLink_label'>{item.label}</a></span></DisabledPrompt>)
      }
     
    }
    return links;
  },[])  
 
  return(
    <WidgetContainer className={className + " quick-links-widget"}>
      <ContentHeaderView text="Quick Links" data-point="quick-links-_Header" />
     {links}
    </WidgetContainer>
  );
}